import './App.css';
import 'bootstrap/dist/css/bootstrap.css';

import { useState } from "react";

import { Image, Article, Section, DocsIntro, DocsHeader, SectionHeader, DocsHeading } from './extra/Components';

import { Intro, introHeader, klubbenSection, riskSection, sff } from "./sections/Intro";
import { Material, materialRigg, materialSkarm } from "./sections/Material";
import { Content } from "./extra/Components";

import { Faltet, faltetBanor, faltetFlygplanet, faltetHangar, faltetHeader, faltetKlubbstuga, faltetNodhopp } from './sections/Faltet';
import { frifalletsPri, Hoppet, hoppetAff1, hoppetDrag, hoppetHojd, hoppetTecken, hoppetUthopp } from './sections/Hoppet';
import { UnderSkarm, underSkarmHurFlyger, underSkarmKallotdrill, underSkarmKommunikation, underSkarmLekområde, underSkarmMoln, underSkarmTaSigHem, underSkarmTurbulens } from './sections/Underskarm';
import { felfunkBeslutshojd, felfunkBraFallskärm, felfunkHogfarLagfart, felfunkIntro, felfunkReservdrag, felfunkSelprov, Felfunktioner } from './sections/Felfunkioner';
import { Landning, landningBargning, landningFlar, landningIntro, landningRiktning, landningRullning, landningUte, LandningVarv } from './sections/Landning';
import Packning from './sections/Packning';
import { Aff, affLevels } from './sections/Aff';
import StorQuiz from './sections/Storquiz';
import ALicens from './sections/Alicens';
import Vidare from './sections/Vidare';

import { useParams, useNavigate } from 'react-router-dom';
import {
    faListCheck,
    faTools,
    faMapSigns,
    faHandPointLeft,
    faPersonThroughWindow,
    faSkullCrossbones,
    faPersonFalling,
    faParachuteBox,
    faPlaneArrival,
    faKitMedical,
    faBoxesPacking,
    faInfo,
    faDiceOne,
    faDiceTwo,
    faDiceThree,
    faDiceFour,
    faDiceFive,
    faDiceSix,
    faTrophy,
    faTriangleExclamation,
    faLayerGroup,

} from '@fortawesome/free-solid-svg-icons';

//import affExit from './assets/1 intro/4 klubben-small.jpg';
import affExit from './assets/4 hoppet/10 aff exit-small.jpg';
import aff1 from './assets/4 hoppet/11 aff 1 i firfall-small.jpg';
import flygaSkarm from './assets/5 fallskarm/8 flyga fallskärm-small.jpg'

import ova from './assets/10 drillande/2 öva-small.jpg'


function App() {
    let params = useParams();
    var club = params.club ?? "syd";
    var article = params.article;

    const navigate = useNavigate();
    var setClub = (e) => navigate('/' + e);
    var setArticle = (e) => navigate('/' + club + "/" + e);

    const [section, setSection] = useState(null);
    const targets = { setSection: setSection, setArticle: setArticle }

    switch (params.club) {
        case "syd":
        case undefined:
            return (
                <Content section={section} article={article} setArticle={setArticle} oneBig={false} club={club} setClub={setClub}>
                    {Intro(targets)}
                    {Material(targets)}
                    {Faltet(targets)}
                    {Hoppet(targets)}
                    {UnderSkarm(targets)}
                    {Felfunktioner(targets)}
                    {Landning(targets)}
                    {Packning(targets)}
                    {Aff(targets)}
                    {StorQuiz(targets)}
                    {ALicens(targets)}
                    {Vidare(targets)}
                </Content>);
        case "sydLong":
            return (
                <Content section={section} article={article} setArticle={setArticle} oneBig={true} club={club} setClub={setClub}>
                    {Intro(targets)}
                    {Material(targets)}
                    {Faltet(targets)}
                    {Hoppet(targets)}
                    {UnderSkarm(targets)}
                    {Felfunktioner(targets)}
                    {Landning(targets)}
                    {Packning(targets)}
                    {Aff(targets)}
                    {StorQuiz(targets)}
                    {ALicens(targets)}
                    {Vidare(targets)}
                </Content>
            )
        case "sydKort":
            return (
                <Content section={section} article={article} setArticle={setArticle} oneBig={false} club={club} setClub={setClub}>
                    {/** {TodoKort(targets)} **/}
                    <Article id="introduktionkort" icon={faMapSigns} name="Intro" setArticle={setArticle} setSection={setSection} >
                        {introHeader}
                        <Section id="klubbIntro" name="Fallskärmsklubben Syd" skipBorder={true}>
                            {klubbenSection}
                            {sff}
                        </Section>

                        <Section id="eslövsflygfällt" name="Eslövs flygfällt" skipBorder={true}>
                            {faltetHeader}
                            {/** faltetBanor **/}
                            {faltetHangar}
                            {faltetKlubbstuga}
                        </Section>
                        {riskSection}

                    </Article>
                    <Article id="utrustningkort" icon={faTools} name="Utrustning" setArticle={setArticle} setSection={setSection} >
                        <DocsIntro></DocsIntro>
                        {/** <Section id="delarrigg" name="Delar rigg"></Section> 
                        <Section id="delarskärm" name="Delar skärm"></Section> */}
                        {materialRigg}
                        {materialSkarm}
                    </Article>
                    <Article id="drakort" icon={faHandPointLeft} name="Dra fallskärmen" setArticle={setArticle} setSection={setSection} >
                        <DocsHeader>
                            <DocsHeading note="">Drag av fallskärm</DocsHeading>
                            <DocsIntro>
                                <p>Frifallet är den centrala delen i fallskärmshoppning. Den har tre stycken huvudregler:</p>
                                {frifalletsPri}
                            </DocsIntro>
                        </DocsHeader>
                        {hoppetDrag}
                        {hoppetHojd}
                    </Article>
                    <Article id="felfunktionerkort" icon={faSkullCrossbones} name="Felfunktioner" setArticle={setArticle} setSection={setSection} >

                        {felfunkIntro}
                        {felfunkBraFallskärm}
                        {felfunkHogfarLagfart}

                        {felfunkReservdrag}
                        {felfunkBeslutshojd}
                    </Article>
                    <Article id="exitkort" icon={faPersonThroughWindow} name="Exit" setArticle={setArticle} setSection={setSection} >
                        <DocsIntro>
                            <DocsHeader>
                                <DocsHeading>Exit, ta sig ur flygplanet</DocsHeading>
                                <Image image={affExit} />
                                <p>
                                    Att hoppa ut tre personer samtidigt och stabilt ur ett flygplan kräver synkronisering och kommunikation.
                                </p>
                            </DocsHeader>
                        </DocsIntro>
                        {hoppetUthopp}
                        {faltetFlygplanet}
                        <Section id="nödhopp" name="Nödhopp">
                            {faltetNodhopp}
                        </Section>
                    </Article>
                    <Article id="firstJumpkort" icon={faPersonFalling} name="Första hoppet" setArticle={setArticle} setSection={setSection} >
                        <DocsIntro>
                            <DocsHeader>
                                <DocsHeading>Första hoppet</DocsHeading>
                                <Image image={aff1} />
                                <p>Målet i det första hoppet är att kunna bryta genom chocken från att hoppa ur ett flygplan för
                                    första gången och klara av att läsa sin höjdmätare.</p>
                            </DocsHeader>
                        </DocsIntro>
                        {hoppetAff1}
                        {hoppetTecken}
                    </Article>
                    <Article id="flyParachutekort" icon={faParachuteBox} name="Flyga fallskärm" setArticle={setArticle} setSection={setSection} >
                        <DocsIntro>
                            <DocsHeader>
                                <DocsHeading>Flyga fallskärm</DocsHeading>
                                <Image image={flygaSkarm} />
                                <p>Fallskärmen flyger framåt om opåverkad. Den svänger höger om man drar i höger styrhandtag och vänster
                                    om man drar i vänster. Drar man båda samtidigt bromsar den in.
                                    Till synes enkelt men det krävs ändå en del erfarenhet att landa där man vill.
                                </p>
                            </DocsHeader>
                        </DocsIntro>
                        {underSkarmHurFlyger}
                        {LandningVarv}
                        {underSkarmKommunikation}
                        <Section id="landaflyga" name="Landning">
                            {landningIntro}
                        </Section>
                        {underSkarmTurbulens}
                    </Article>
                    <Article id="landingkort" icon={faPlaneArrival} name="Landa" setArticle={setArticle} setSection={setSection} >
                        <DocsIntro>
                            {landningFlar}
                        </DocsIntro>
                        {landningRullning}
                        {landningUte}
                    </Article>
                    <Article id="reservdragkort" icon={faKitMedical} name="Öva" setArticle={setArticle} setSection={setSection} >
                        <DocsIntro>
                            <DocsHeading>Övning ger färdighet</DocsHeading>
                            <Image image={ova} />
                            <p>
                                Så mycket som möjligt vill vi bygga muskelminne på marken för saker vi ska göra i luften.
                                Momenten i den här manualen bör repeteras många gånger tillsammans med instruktör.
                            </p>
                        </DocsIntro>
                        {felfunkSelprov}
                    </Article>
                    <Article id="packingkort" icon={faBoxesPacking} name="Packning" setArticle={setArticle} setSection={setSection} >
                        <DocsIntro></DocsIntro>
                        <Section id="wip " name="Work in progress här --------------------------"></Section>
                        <Section id="praktisk repetition" name="Praktisk repetition"></Section>
                    </Article>
                    <Article id="felfunkisarMerkort" icon={faTriangleExclamation} name="Felfunktioner" setArticle={setArticle} setSection={setSection} >
                        <DocsIntro></DocsIntro>
                        <Section id="kända" name="Kända"></Section>
                        <Section id="okända" name="Okända"></Section>
                    </Article>


                    <Article id="aff1" icon={faDiceOne} name="Aff hopp 1" setArticle={setArticle} setSection={setSection} >
                        <DocsIntro></DocsIntro>
                        <Section id="program1" name="Program">
                            {affLevels[0]}
                        </Section>
                        <Section id="inför2" name="Inför hopp 2"></Section>
                        <Section id="mer utrustning" name="Utrustning">
                            <div>
                                <div>Utrustningen</div>
                                <div>-- Delarnas namn och funktion</div>
                                <div>-- Utrustningens nödsystemen (RSL/ADD/MARD)</div>
                                <div>-- Rservsdragsproceduren</div>
                                <div>-- Kännetecken för fungerande fallskärm</div>
                                <div>-- Felfunktioner + lösningar</div>
                                <div>-- Driftstörningar + lösningar</div>
                            </div>
                        </Section>
                    </Article>
                    <Article id="aff2" icon={faDiceTwo} name="Aff hopp 2" setArticle={setArticle} setSection={setSection} >
                        <DocsIntro></DocsIntro>
                        <Section id="program2" name="Program">
                            {affLevels[1]}
                        </Section>
                        <Section id="inför3" name="Inför hopp 3"></Section>
                        <Section id="iochrunt2" name="I och runt flygplanet">
                            <div>
                                <div>I och runt flygplaner</div>
                                <div>-- Ilastning (bältet, kom p&aring;kl&auml;dd)</div>
                                <div>-- Flyga upp/&aring;ka ner</div>
                                <div>-- N&ouml;dhopp</div>
                            </div>
                        </Section>
                    </Article>
                    <Article id="aff3" icon={faDiceThree} name="Aff hopp 3" setArticle={setArticle} setSection={setSection} >
                        <DocsIntro></DocsIntro>
                        <Section id="Program3" name="Program">
                            {affLevels[2]}

                        </Section>
                        <Section id="inför4" name="Inför hopp 4"></Section>
                        <Section id="Frifallf" name="I och runt flygplanet">
                            <div>
                                <div>Frifall</div>
                                <div>-- Fartvinden vid uthopp</div>
                                <div>-- Frifallstekniker (sv&auml;ng, delta, hiss, broms)</div>
                            </div>
                        </Section>


                    </Article>
                    <Article id="aff4" icon={faDiceFour} name="Aff hopp 4" setArticle={setArticle} setSection={setSection} >
                        <DocsIntro></DocsIntro>
                        <Section id="Program4" name="Program">
                            {affLevels[3]}

                        </Section>
                        <Section id="inför5" name="Inför hopp 5"></Section>
                        <Section id="fallskärm" name="Fallskärm">
                            <div>
                                <div>Fallsk&auml;rm</div>
                                <div>-- Lyftkraft, egendrivning</div>
                                <div>-- Skapa glidtal (ta sig hem)</div>
                                <div>-- Olika s&auml;tt att styra sk&auml;rmen</div>
                                <div>-- Trafikregler</div>
                                <div>-- Landningsvarv (v&auml;nter och h&ouml;ger)</div>
                            </div>
                        </Section>
                    </Article>
                    <Article id="aff5" icon={faDiceFive} name="Aff hopp 5" setArticle={setArticle} setSection={setSection} >
                        <DocsIntro></DocsIntro>
                        <Section id="Program5" name="Program">
                            {affLevels[4]}
                        </Section>
                        <Section id="inför6" name="Inför hopp 6"></Section>
                        <Section id="TurbulensochUte" name="Turbulens och utelandningar">
                            <div>
                                <div>Turbulens och utllandingar</div>
                                <div>-- Vad &auml;r turbulens? Var finns det?</div>
                                <div>-- Vad &auml;r termik? Var finns det?</div>
                                <div>-- Vad &auml;r d&aring;liga landningsplatser? Varf&ouml;r?</div>
                                <div>-- V&auml;lja bra alternativ f&ouml;r utelandning.</div>
                            </div>
                        </Section>
                    </Article>
                    <Article id="aff6" icon={faDiceSix} name="Aff hopp 6" setArticle={setArticle} setSection={setSection} >
                        <DocsIntro></DocsIntro>
                        <Section id="Program6" name="Program">
                            {affLevels[5]}

                        </Section>
                        <Section id="inför7" name="Inför hopp 7"></Section>
                        <Section id="landa" name="Mer om landning">
                            <div>
                                <div>Landa</div>
                                <div>-- Landningsvarv (planera)</div>
                                <div>-- Landa mot vinden</div>
                                <div>-- Landa sidvind (ingen fara - lokala regler)</div>
                                <div>-- Rullning (hur och varf&ouml;r)</div>
                            </div>
                        </Section>
                    </Article>
                    <Article id="aff7" icon={faTrophy} name="Aff hopp 7" setArticle={setArticle} setSection={setSection} >
                        <DocsIntro></DocsIntro>
                        <Section id="Program7" name="Program">
                            {affLevels[6]}
                        </Section>
                        <Section id="inför8" name="Inför hopp 8">

                            <Section id=".-.-." name="------------------"></Section>

                            {underSkarmKallotdrill}
                            {underSkarmTaSigHem}
                            {underSkarmLekområde}
                            {underSkarmMoln}


                            {landningRiktning}
                            {landningBargning}
                        </Section>
                    </Article>
                    <Article id="affvidare" icon={faLayerGroup} name="Vidare aff-hopp" setArticle={setArticle} setSection={setSection} >
                        <DocsIntro></DocsIntro>
                        <Section id="Program8" name="Aff 8" >
                            {affLevels[7]}
                        </Section>
                        <Section id="Program9" name="Aff 9" >
                            {affLevels[8]}
                        </Section>
                        <Section id="Program10" name="Aff 10" >
                            {affLevels[9]}
                        </Section>
                        <Section id="ProgramAffMer" name="Aff 11 - 25" >
                            <SectionHeader>Aff 11 - 25: Hoppellihopp</SectionHeader>
                        </Section>

                        <Section id="okänt" name="?"></Section>
                    </Article>
                </Content>
            )
        default:
            return <p>Något gick väldigt fel i att välja klubb</p>
    }
}


const TodoKort = ({ setSection, setArticle }) => (
    <Article name="Att göra" icon={faListCheck} id="attgora" setArticle={setArticle} setSection={setSection}>
        <DocsHeader >
            <h1 className="docs-heading">Kortkurs, Kursupplägg 8h <span className="docs-time">Last updated:
                2026-03-25</span>
            </h1>
            <DocsIntro>
            </DocsIntro>
        </DocsHeader >
        <Section id="Kursupplägg" name="Kursupplägg" >
            <p>
                Intro och  hälsa och säkerhet (45min)
            </p>
            <ul>
                <li>
                    Kort om oss, Kort om er
                </li>
                <li>
                    Kort om fältet vi är på
                </li>
            </ul>
        </Section>
        <Section id="Utrustning" name="Utrustning" >
            <p>
                Utrustning (90 min)
            </p>
            <ul>
                <li>
                    Ganska grundlig genomgång
                </li>
                <li>
                    Repetera! Postit-övning
                </li>
            </ul>
        </Section>
        <Section id=" Dra fallskärmen " name=" Dra fallskärmen " >
            <p>
                Dra fallskärmen (30 min)
            </p>
            <ul>
                <li>
                    Visa, träna drag
                </li>
                <li>
                    Prata draghöjd
                </li>
                <li>
                    Viktig färdighet att känna sig trygg med!
                </li>
                <li>
                    Träna kasta pilot i riktig elevrigg
                </li>
            </ul>
        </Section>
        <Section id="Felfunktioer" name="Felfunktioer" >
            <p>
                Felfunktioner (30 min)
            </p>
            <ul>
                <li>
                    Prata harddeck. 1000m. Sparka snodd. Två flär.
                </li>
                <li>
                    Is it there? Is it square? does it flare?
                </li>
                <li>
                    Prata om hög- låg och felfunkisar. filmer tar vi sen. Vad tittar man efter?
                </li>
            </ul>
        </Section>
        <Section id="Exit" name="Exit" >
            <p>
                Exit (30 min)
            </p>
            <ul>
                <li>
                    Prata exit
                </li>
                <li>
                    Prata om i och runt flygplanet
                </li>
                <li>
                    Prata nödhopp
                </li>
            </ul>
        </Section>
        <Section id="Första hoppet" name="Första hoppet" >
            <p>
                Första hoppet (45 min)
            </p>
        </Section>
        <Section id="Flyga fallskärm" name="Flyga fallskärm" >
            <p>
                Flyga fallskärm (30 min)
            </p>
            <ul>
                <li>

                    Prata trafikvarv
                </li>
                <li>
                    Prata väjningsplikt
                </li>
                <li>
                    Prata styr- och bromsdon
                </li>
                <li>
                    Prata om att landa sin fallskärm
                </li>
                <li>
                    Turbulent och termik
                </li>
            </ul>
        </Section>
        <Section id="Landa" name="Landa" >
            <p>
                Landa (30 min)
            </p>
            <ul>
                <li>
                    Rulla
                </li>
                <li>
                    Landa utanför hoppfältet
                </li>
            </ul>
        </Section>
        <Section id="Reservdrag" name="Reservdrag" >
            <p>
                Reservdrag/sele (30 min)
            </p>
            <ul>
                <li>
                    Visa och träna drag
                </li>
                <li>
                    Dummy!
                </li>
                <li>
                    sparka snodd. rimligt scenario första hoppen.
                </li>
                <li>
                    Viktig färdighet att känna sig trygg med.
                </li>
            </ul>
        </Section>
        <Section id="Packing" name="Packing" >
            <p>
                Packing (rep. utrustning) (30 min)
            </p>
            <ul>
                <li>
                    Visa packning
                </li>
                <li>
                    Passa på att repetera utrustningens delar
                </li>
            </ul>
        </Section>
        <Section id="filmer" name="filmer" >
            <p>
                Gemensamma filmer av felfunktioner och sånt (90 min)
            </p>
            <ul>
                <li>
                    Filmer
                </li>
                <li>
                    Kaffe
                </li>
                <li>
                    Diskussioner
                </li>
            </ul>
        </Section>
    </Article >);

export default App;
